<template>
  <Sidebar>
    <SidebarHeader>
      <router-link to="/" class="flex items-center justify-start px-2 text-white">
        <vue-feather type="chevron-left" class="h-8" />
        <span class="text-sm font-semibold">Dashboard</span>
      </router-link>
    </SidebarHeader>
    <SidebarContent>
      <MenuGroups :groups="menuGroups" />
    </SidebarContent>
  </Sidebar>
</template>
<script setup lang="ts">
import MenuGroups from '@/components/shared/sidebar/MenuGroups.vue';
import { useSettingsSidebar } from './useSettingsSidebar.ts';
import { Sidebar, SidebarContent, SidebarHeader } from '@/components/ui/sidebar';

const { menuGroups } = useSettingsSidebar();
</script>
